var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative bg-white"},[_c('Header'),_c('vue-page-transition',{attrs:{"name":"fade-in-down"}},[_c('router-view',{key:_vm.$route.fullPath})],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }